import React from 'react';

export default function Certificates({ setCurrentPage = () => {} }) {
  // Existing certificates registry array
  const certs = [
   ];

  // Registry for your 3-page GST certificate asset array
  const gstPages = [
    { pageNum: 1, img: '/images/gst_page1.png' },
    { pageNum: 2, img: '/images/gst_page2.png' },
    { pageNum: 3, img: '/images/gst_page3.png' }
  ];

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh', // Forces page to full height, pinning footer perfectly
      backgroundColor: '#f8fafc',
      fontFamily: '"Inter", sans-serif' 
    }}>
      
      {/* Main Content Container */}
      <div style={{ flex: '1', maxWidth: '1200px', width: '100%', margin: '0 auto', padding: '60px 20px', boxSizing: 'border-box' }}>
        <h2 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#0c4a6e', marginBottom: '10px', textAlign: 'center' }}>Compliance & Certificates</h2>
        <p style={{ textAlign: 'center', color: '#64748b', marginBottom: '50px', fontSize: '1.1rem' }}>Our operational standards are certified by leading international maritime regulatory organizations.</p>

        {/* NEW SECTION: ALL-IN-ONE SINGLE BOX FOR 3-PAGE GST CERTIFICATE */}
        <div style={{ 
          backgroundColor: '#ffffff', 
          borderRadius: '16px', 
          border: '1px solid #e2e8f0', 
          boxShadow: '0 10px 25px -5px rgba(0,0,0,0.05)', 
          padding: '30px',
          marginBottom: '60px'
        }}>
          <div style={{ marginBottom: '24px', borderBottom: '1px solid #f1f5f9', paddingBottom: '16px' }}>
            <h3 style={{ margin: '0 0 6px 0', fontSize: '1.5rem', color: '#0c4a6e', fontWeight: '800' }}>
              GST Registration Certificate
            </h3>
            <p style={{ margin: 0, color: '#64748b', fontSize: '0.9rem' }}>
              Official 3-page Government of India Goods and Services Tax identification record verification.
            </p>
          </div>

          {/* Flex wrap sub-grid holding all 3 page assets side-by-side */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
            {gstPages.map((page) => (
              <div 
                key={page.pageNum} 
                style={{ 
                  flex: '1', 
                  minWidth: '280px', 
                  maxWidth: '340px',
                  backgroundColor: '#f8fafc', 
                  border: '1px solid #cbd5e1', 
                  borderRadius: '8px', 
                  padding: '12px',
                  textAlign: 'center'
                }}
              >
                <div style={{ height: '420px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#ffffff', overflow: 'hidden', borderRadius: '4px', border: '1px solid #e2e8f0' }}>
                  <img 
                    src={page.img} 
                    alt={`GST Certificate Page ${page.pageNum}`} 
                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    onError={(e) => { e.target.src = `https://placehold.co/300x400?text=GST+Page+${page.pageNum}`; }}
                  />
                </div>
                <div style={{ marginTop: '10px', fontSize: '0.85rem', fontWeight: '700', color: '#475569' }}>
                  Page {page.pageNum}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* STANDARD SINGLE-COLUMN INDEPENDENT HIGHLIGHT CARDS GRID */}
        <h3 style={{ fontSize: '1.6rem', fontWeight: '800', color: '#0c4a6e', marginBottom: '30px', textAlign: 'center' }}>
         
        </h3>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
          {certs.map(cert => (
            <div key={cert.id} style={{ backgroundColor: '#ffffff', borderRadius: '12px', overflow: 'hidden', border: '1px solid #e2e8f0', width: '350px', boxShadow: '0 4px 12px rgba(0,0,0,0.02)' }}>
              <div style={{ height: '400px', backgroundColor: '#f8fafc', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
                <img 
                  src={cert.image} 
                  alt={cert.title} 
                  style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', border: '1px solid #cbd5e1' }}
                  onError={(e) => { e.target.src = "https://placehold.co/300x400?text=Certificate+Image"; }}
                />
              </div>
              <div style={{ padding: '20px', borderTop: '1px solid #f1f5f9' }}>
                <h4 style={{ margin: '0 0 8px 0', fontSize: '1.1rem', color: '#0c4a6e', fontWeight: '700' }}>{cert.title}</h4>
                <p style={{ margin: 0, color: '#64748b', fontSize: '0.85rem', lineHeight: '1.4' }}>{cert.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Professional Corporate Footer */}
      <footer style={{ 
        backgroundColor: '#0f172a', 
        color: '#94a3b8', 
        padding: '40px 20px', 
        marginTop: 'auto', 
        borderTop: '1px solid #1e293b'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '30px' }}>
          <div>
            <h5 style={{ color: '#ffffff', fontSize: '1.1rem', fontWeight: '700', margin: '0 0 10px 0' }}>Shabaaz Trading Co.</h5>
            <p style={{ fontSize: '0.9rem', maxWidth: '320px', lineHeight: '1.5', margin: 0 }}>
              Global distributors of premium commercial maritime parts, heavy deck machinery, and raw components.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '60px', flexWrap: 'wrap' }}>
            <div>
              <h6 style={{ color: '#ffffff', fontWeight: '600', margin: '0 0 12px 0', fontSize: '0.95rem' }}>Navigation</h6>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '0.9rem', lineHeight: '2.2' }}>
                <li><button onClick={() => setCurrentPage('home')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>Home</button></li>
                <li><button onClick={() => setCurrentPage('products')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>Products</button></li>
                <li><button onClick={() => setCurrentPage('about')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>About Us</button></li>
                <li><button onClick={() => setCurrentPage('certificates')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>Certificates</button></li>
                <li><button onClick={() => setCurrentPage('videos')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>Shop Videos</button></li>
                <li><button onClick={() => setCurrentPage('contact')} style={{ background: 'none', border: 'none', color: '#94a3b8', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}>Contact Us</button></li>
              </ul>
            </div>
            <div>
              <h6 style={{ color: '#ffffff', fontWeight: '600', margin: '0 0 12px 0', fontSize: '0.95rem' }}>Supply Desk</h6>
              <p style={{ fontSize: '0.9rem', margin: '0 0 6px 0' }}>Support: shabaaztradingco04@gmail.com</p>
              <p style={{ fontSize: '0.9rem', margin: 0 }}>WhatsApp: +91 90162 35501</p>
            </div>
          </div>
        </div>
        <div style={{ maxWidth: '1200px', margin: '30px auto 0 auto', paddingTop: '20px', borderTop: '1px solid #1e293b', fontSize: '0.85rem', textAlign: 'center' }}>
          &copy; {new Date().getFullYear()} Shabaaz Trading Co. Marine Distribution Network. All rights reserved.
        </div>
      </footer>

    </div>
  );
}